import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scroll-container" }

import { computed, onMounted, provide, ref, watch } from 'vue';
import RegisterLoginPopup from './view/loginRegister/registerLoginPopup.vue';
import { playClickSound } from './utils/media';
import { useThemeStore } from './stores/theme';
import { useUserStore } from './stores/user';
import LogoutPopupOne from './themes/themeOne/profile/components/logoutPopup.vue';
import LogoutPopupTwo from './themes/themeTwo/profile/components/logoutPopup.vue';
import { subscribeUserToPush } from './utils/push';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const logOutRef = ref()
const registerRef = ref()
const themeStore = useThemeStore()
const userStore = useUserStore()

provide('openLogoutPopup', () => {
  logOutRef.value.open()
});

provide('openRegisterLoginPopup', (type: number) => {
  playClickSound()
  registerRef.value.open(type)
});

(window as any).openLoginPopup = (type: number) => {
  playClickSound();
  registerRef.value.open(type);
};

// Watch for user login to subscribe to push notifications
watch(() => userStore.id, (newId, oldId) => {
  if (newId && !oldId) {
    subscribeUserToPush();
  }
}, { immediate: true }); // Use immediate to check on initial load

const applyBodyBackground = () => {
  if (themeStore.themeIndex === 1) {
    document.body.style.backgroundColor = '#27190d'
  } else if (themeStore.themeIndex === 2) {
    document.body.style.backgroundColor = 'rgb(49, 39, 52)'
  } else {
    document.body.style.backgroundColor = '#27190d'
  }
}
const appStyle = computed(() => {
  let style: Record<string, string> = {};

  if (themeStore.themeIndex === 1) {
    style.backgroundImage = `url(${new URL('@/assets/main_bg.png', import.meta.url).href})`;
    style.backgroundSize = 'cover';
    style.backgroundRepeat = 'repeat';
    style.backgroundColor = '#27190d';
  } else if (themeStore.themeIndex === 2) {
    style.backgroundColor = '#221b24';
    style.backgroundImage = 'none';
    style.backgroundSize = 'cover';
    style.backgroundRepeat = 'repeat';
  } else {
    style.backgroundColor = '#27190d';
    style.backgroundImage = `url(${new URL('@/assets/main_bg.png', import.meta.url).href})`;
    style.backgroundSize = 'cover';
    style.backgroundRepeat = 'repeat';
  }

  return style;
});
onMounted(() => {
  applyBodyBackground()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    style: _normalizeStyle(appStyle.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        name: "slide-left",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_RouterView)
        ]),
        _: 1
      })
    ]),
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createBlock(LogoutPopupOne, {
          key: 0,
          ref_key: "logOutRef",
          ref: logOutRef
        }, null, 512))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createBlock(LogoutPopupTwo, {
          key: 1,
          ref_key: "logOutRef",
          ref: logOutRef
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(RegisterLoginPopup, {
      ref_key: "registerRef",
      ref: registerRef
    }, null, 512)
  ], 4))
}
}

})